export default [
  {
    name: 'partnerManagement',
    label: 'labels.partnerManagement',
    permissionKey: 'partner_management',
    children: [
      {
        name: 'partner_add',
        label: 'labels.partnerAdd',
        permissionKey: 'partner_add'
      },
      {
        name: 'partner_edit',
        label: 'labels.partnerEdit',
        permissionKey: 'partner_edit'
      },
      {
        name: 'partner_delete',
        label: 'labels.partnerDelete',
        permissionKey: 'partner_delete'
      },
      {
        name: 'partner_archive',
        label: 'labels.partnerArchive',
        permissionKey: 'partner_archive'
      },
      // {
      //   name: 'partner_restore',
      //   label: 'labels.partnerRestore',
      //   permissionKey: 'partner_restore'
      // },
      {
        name: 'partner_confirm_status_markup',
        label: 'labels.confirmMarkup',
        permissionKey: 'partner_confirm_status_markup'
      },
      {
        name: 'partner_approve_contract',
        label: 'labels.partnerApproveContract',
        permissionKey: 'partner_approve_contract'
      },
      {
        name: 'partnerDocumentManagement',
        label: 'labels.partnerDocumentManagement',
        permissionKey: 'partner_document_management',
        isChecked: false,
        children: [
          {
            name: 'partner_document_add',
            label: 'labels.partnerDocumentAdd',
            permissionKey: 'partner_document_add',
            isChecked: false
          },
          {
            name: 'partner_document_edit',
            label: 'labels.partnerDocumentEdit',
            permissionKey: 'partner_document_edit',
            isChecked: false
          },
          {
            name: 'partner_document_delete',
            label: 'labels.partnerDocumentDelete',
            permissionKey: 'partner_document_delete',
            isChecked: false
          },
          {
            name: 'partner_document_archive',
            label: 'labels.partnerDocumentArchive',
            permissionKey: 'partner_document_archive',
            isChecked: false
          }
          // {
          //   name: 'partner_document_restore',
          //   label: 'labels.partnerDocumentRestore',
          //   permissionKey: 'partner_document_restore',
          //   isChecked: false
          // }
        ]
      },
      {
        name: 'partnerCommodityManagement',
        label: 'labels.partnerCommodityManagement',
        permissionKey: 'partner_commodity_management',
        isChecked: false,
        children: [
          {
            name: 'partner_commodity_add',
            label: 'labels.partnerCommodityAdd',
            permissionKey: 'partner_commodity_add',
            isChecked: false
          },
          {
            name: 'partner_document_edit',
            label: 'labels.partnerCommodityEdit',
            permissionKey: 'partner_commodity_edit',
            isChecked: false
          },
          {
            name: 'partner_commodity_delete',
            label: 'labels.partnerCommodityDelete',
            permissionKey: 'partner_commodity_delete',
            isChecked: false
          },
          {
            name: 'partner_document_archive',
            label: 'labels.partnerCommodityArchive',
            permissionKey: 'partner_commodity_archive',
            isChecked: false
          }
          // {
          //   name: 'partner_commodity_restore',
          //   label: 'labels.partnerCommodityRestore',
          //   permissionKey: 'partner_commodity_restore',
          //   isChecked: false
          // }
        ]
      },
      {
        name: 'partnerContactManagement',
        label: 'labels.partnerContactManagement',
        permissionKey: 'partner_contact_management',
        isChecked: false,
        children: [
          {
            name: 'partner_contact_add',
            label: 'labels.partnerContactAdd',
            permissionKey: 'partner_contact_add',
            isChecked: false
          },
          {
            name: 'partner_contact_edit',
            label: 'labels.partnerContactEdit',
            permissionKey: 'partner_contact_edit',
            isChecked: false
          },
          {
            name: 'partner_contact_delete',
            label: 'labels.partnerContactDelete',
            permissionKey: 'partner_contact_delete',
            isChecked: false
          },
          {
            name: 'partner_contact_archive',
            label: 'labels.partnerContactArchive',
            permissionKey: 'partner_contact_archive',
            isChecked: false
          }
          // {
          //   name: 'partner_contact_restore',
          //   label: 'labels.partnerContactRestore',
          //   permissionKey: 'partner_contact_restore',
          //   isChecked: false
          // }
        ]
      },
      {
        name: 'businessOpportunity',
        label: 'labels.businessOpportunityManagement',
        permissionKey: 'partner_business_opportunity_management',
        isChecked: false,
        children: [
          {
            name: 'partner_business_opportunity_add',
            label: 'labels.addBusinessOpportunity',
            permissionKey: 'partner_business_opportunity_add',
            isChecked: false
          },
          {
            name: 'partner_business_opportunity_edit',
            label: 'labels.editBusinessOpportunity',
            permissionKey: 'partner_business_opportunity_edit',
            isChecked: false
          },
          {
            name: 'partner_business_opportunity_delete',
            label: 'labels.deleteBusinessOpportunity',
            permissionKey: 'partner_business_opportunity_delete',
            isChecked: false
          },
          {
            name: 'partner_business_opportunity_replicate',
            label: 'labels.replicateBusinessOpportunity',
            permissionKey: 'partner_business_opportunity_replicate',
            isChecked: false
          },
          {
            name: 'partner_business_opportunity_archive',
            label: 'labels.archiveBusinessOpportunity',
            permissionKey: 'partner_business_opportunity_archive',
            isChecked: false
          }
          // {
          //   name: 'partner_business_opportunity_restore',
          //   label: 'labels.restoreBusinessOpportunity',
          //   permissionKey: 'partner_business_opportunity_restore',
          //   isChecked: false
          // }
        ]
      },
      {
        name: 'partner_bank_management',
        label: 'labels.bankAccountManagement',
        permissionKey: 'partner_bank_management',
        isChecked: false,
        children: [
          {
            name: 'partner_bank_add',
            label: 'labels.bankAccountAdd',
            permissionKey: 'partner_bank_add',
            isChecked: false
          },
          {
            name: 'partner_bank_edit',
            label: 'labels.bankAccountEdit',
            permissionKey: 'partner_bank_edit',
            isChecked: false
          },
          {
            name: 'partner_bank_delete',
            label: 'labels.bankAccountDelete',
            permissionKey: 'partner_bank_delete',
            isChecked: false
          },
          {
            name: 'partner_bank_archive',
            label: 'labels.bankAccountArchive',
            permissionKey: 'partner_bank_archive',
            isChecked: false
          }
          // {
          //   name: 'partner_bank_restore',
          //   label: 'labels.bankAccountRestore',
          //   permissionKey: 'partner_bank_restore',
          //   isChecked: false
          // }
        ]
      },
      {
        name: 'partner_task_completion_time_management',
        label: 'labels.completionTimeManagement',
        permissionKey: 'partner_task_completion_time_management',
        isChecked: false,
        children: [
          {
            name: 'partner_task_completion_time_add',
            label: 'labels.addCompletionTime',
            permissionKey: 'partner_task_completion_time_add',
            isChecked: false
          },
          {
            name: 'partner_task_completion_time_edit',
            label: 'labels.editCompletionTime',
            permissionKey: 'partner_task_completion_time_edit',
            isChecked: false
          },
          {
            name: 'partner_task_completion_time_delete',
            label: 'labels.deleteCompletionTime',
            permissionKey: 'partner_task_completion_time_delete',
            isChecked: false
          },
          {
            name: 'partner_task_completion_time_archive',
            label: 'labels.archiveCompletionTime',
            permissionKey: 'partner_task_completion_time_archive',
            isChecked: false
          }
          // {
          //   name: 'partner_task_completion_time_restore',
          //   label: 'labels.restoreCompletionTime',
          //   permissionKey: 'partner_task_completion_time_restore',
          //   isChecked: false
          // }
        ]
      }
    ]
  }
]
